/* eslint-disable no-undef */
import { FunctionComponent } from 'react';
import CourseLanding from './../../components/courseLanding';
import SectionTitle from './../../components/sectionTitle';
import Quiz from './../../components/quiz';
import Conversation from './conversation';
import Animation038 from './animation038';
import Animation025 from './animation025';
import Component003 from './component003';
import Component004 from './component004';
import Animation011 from './animation011';
import Animation041 from './animation041';
import Animation008 from './animation008';
import Component005 from './component005';
import Component002 from './component002';
import Animation024 from './animation024';
import Animation028 from './animation028';
import Animation002 from './animation002';
import Animation023 from './animation023';
import Animation026 from './animation026';
import Animation042 from './animation042';
import Animation006 from './animation006';
import Component006 from './component006';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Animation002,
  Animation006,
  Animation008,
  Animation011,
  Animation023,
  Animation024,
  Animation025,
  Animation026,
  Animation028,
  Animation038,
  Animation041,
  Animation042,
  Component002,
  Component003,
  Component004,
  Component005,
  Component006,
};

export default Components;
